<template>
    <div class="VOCTemplateGeneration">
        <!--VOCTemplateGeneration-->
        <div class="VOCTemplateGenerationContent">
            <editor v-model="form.body"></editor>
        </div>
        <div class="VOCTemplateGenerationBtn">
            <el-button type="primary" @click="Generation">生成文档</el-button>
        </div>


        <el-dialog
                :visible.sync="dialogVisible"
                width="50%"
        >
            <div>
                <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="上级菜单" prop="menuId" v-if="options&&options.length">
                        <el-cascader
                                v-model="form.menuId"
                                :key="cascaderKey"
                                :options="options"
                                :props="{
                                    label:'title',
                                    value:'menuId',
                                    children:'children',
                                    checkStrictly :true
                                }"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="菜单名称" prop="menuName">
                        <el-input
                                v-model="form.menuName"
                        >
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')">生成文档</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Editor from "../../../components/Editor/index";
    import url from "../../../utils/UrlApi"

    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }

    export default {
        name: "VOCTemplateGeneration",
        components: {Editor},
        data() {
            return {
                form: {
                    body: '',
                    menuId: '',
                    menuName: ''
                },
                options: [],
                ruleForm: {
                    data: []
                },
                dialogVisible: false,
                rules: {
                    menuId: [
                        {required: true, message: '请选择上级菜单', trigger: 'change'}
                    ],
                    menuName: [
                        {required: true, message: '请输入菜单名称', trigger: 'change'}
                    ],
                },
                cascaderKey: 1,
            }
        },
        methods: {
            Generation() {
                this.dialogVisible = true
                this.$http.get(url.menuCityTree, {}).then(res => {
                    if (res.data.code === '200') {
                        this.options = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        let data = JSON.parse(JSON.stringify(this.form))
                        data.menuId = data.menuId[data.menuId.length - 1]


                        this.$http.post(url.wordTemplateGenerateWord, data).then(res => {
                            if (res.data.code === '200') {
                                // this.download(res.data.data.url)
                                this.dialogVisible = false
                                this.$message.success('模板生成成功')
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },


            download(urls) {
                let data = {
                    id: '0',
                    type: '3',
                    url: urls,
                    token: localStorage.getItem('token')
                }
                let allUrl = url.wordTemplatedownload + params(data)
                window.open(allUrl, '_blank')
            }
        }
    }
</script>

<style scoped lang="less">
    .VOCTemplateGeneration {
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        .VOCTemplateGenerationContent {
            flex: 1;

            overflow: hidden;
        }
        .VOCTemplateGenerationBtn {
            margin: 10px 0;
            text-align: center;
        }
    }
</style>